<h1 mat-dialog-title>Product Plan Levels for {{data.companyName}}</h1>
<div mat-dialog-content>
  <div class="setting-mode-panel">
    <div class="setting-mode-buttons">
      <button
        *ngIf="canInherit()"
        mat-stroked-button
        type="button"
        [class.active-mode]="mode === 'inherit'"
        (click)="setMode('inherit')">
        Use Parent Setting
      </button>
      <button
        mat-stroked-button
        type="button"
        [class.active-mode]="mode === 'none'"
        (click)="setMode('none')">
        No Plan Restrictions For This Company
      </button>
      <button
        mat-stroked-button
        type="button"
        [class.active-mode]="mode === 'custom'"
        (click)="setMode('custom')">
        Set Custom Plan Levels
      </button>
    </div>
    <p class="setting-mode-help" *ngIf="mode === 'inherit' && canInherit()">
      This company will use Product Plan Levels from {{data.parentCompanyName || 'its parent company'}}.
    </p>
    <p class="setting-mode-help" *ngIf="mode === 'none'">
      This company will explicitly override the parent setting and allow all plan levels for its available products.
    </p>
    <p class="setting-mode-help" *ngIf="mode === 'custom'">
      Select which plan levels should remain available for this company.
    </p>
  </div>

  <app-inlinemessage
    *ngIf="validationMessage"
    level="warning"
    [message]="validationMessage">
  </app-inlinemessage>

  <app-inlinemessage
    *ngIf="products.length === 0"
    level="warning"
    message="No configurable plan levels were found for this company's available products.">
  </app-inlinemessage>

  <div *ngIf="products.length > 0" class="product-plan-list">
    <div class="benefit-product-card" *ngFor="let product of products; trackBy: trackProduct">
      <div class="benefit-product-card-header">
        <mat-checkbox
          class="benefit-product-checkbox"
          [checked]="isBenefitProductSelected(product.id)"
          [indeterminate]="isBenefitProductIndeterminate(product.id)"
          [disabled]="!isCustomMode()"
          (click)="$event.stopPropagation()"
          (change)="onBenefitProductToggle(product.id, $event.checked)">
        </mat-checkbox>

        <div class="benefit-product-logo-wrap">
          <img
            *ngIf="product.imageUrl"
            class="benefit-product-logo"
            [src]="product.imageUrl"
            [alt]="getProductLabel(product) + ' logo'"
            loading="eager"
            decoding="async"
            referrerpolicy="no-referrer"
            (error)="product.imageUrl = ''"
          />
          <div *ngIf="!product.imageUrl" class="benefit-product-logo-placeholder">
            {{ getProductLabel(product).charAt(0) }}
          </div>
        </div>

        <div class="benefit-product-main">
          <div class="benefit-product-name">{{ getProductLabel(product) }}</div>
          <div class="benefit-product-description">
            {{ product.description || product.productName }}
          </div>
        </div>

        <button
          type="button"
          class="benefit-product-expand-btn"
          (click)="toggleBenefitProductExpansion(product.id)">
          <span>{{ getSelectedBenefitPlanCount(product.id) }}/{{ product.plans.length }} plans</span>
          <mat-icon>{{ isBenefitProductExpanded(product.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>

      <div
        *ngIf="isBenefitProductExpanded(product.id)"
        class="benefit-product-plans">
        <div
          class="benefit-product-plan"
          *ngFor="let plan of product.plans; trackBy: trackPlan"
          (click)="onBenefitPlanToggle(product.id, plan.id, !isBenefitPlanSelected(product.id, plan.id))">
          <mat-checkbox
            class="benefit-product-plan-checkbox"
            [checked]="isBenefitPlanSelected(product.id, plan.id)"
            [indeterminate]="isBenefitPlanIndeterminate(product.id, plan.id)"
            [disabled]="!isCustomMode()"
            (click)="$event.stopPropagation()"
            (change)="onBenefitPlanToggle(product.id, plan.id, $event.checked)">
          </mat-checkbox>

          <div class="benefit-product-plan-copy">
            <div class="benefit-product-plan-name">{{ plan.name }}</div>
            <div *ngIf="plan.description" class="benefit-product-plan-description">
              {{ plan.description }}
            </div>
          </div>

          <button
            *ngIf="plan.detailsUrl"
            type="button"
            class="benefit-product-plan-link"
            (click)="openBenefitPlanDetails(plan.detailsUrl, $event)">
            more details
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button class="donebutton" color="primary" (click)="okClicked()">Done</button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
